/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllMediaFilesForBundlesRequest
 */
export interface AllMediaFilesForBundlesRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AllMediaFilesForBundlesRequest
     */
    bundles: Array<number>;
}

export function AllMediaFilesForBundlesRequestFromJSON(json: any): AllMediaFilesForBundlesRequest {
    return AllMediaFilesForBundlesRequestFromJSONTyped(json, false);
}

export function AllMediaFilesForBundlesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllMediaFilesForBundlesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bundles': json['bundles'],
    };
}

export function AllMediaFilesForBundlesRequestToJSON(value?: AllMediaFilesForBundlesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bundles': value.bundles,
    };
}


